
const NoEvents = () => {
    return (
        <div className='flex flex-col justify-center items-center'>
            <img className='size-32' src='/papier.png' alt='No data Img'/>
            <p className='text-gray-700 font-bold'>Aucun évènement trouver</p>
            <p className='text-black'>Veuillez réessayer plus tard</p>
        </div>
    );
};

export default NoEvents;
